export default __webpack_public_path__ + "static/media/NewCTEBackground.0a0e2027.png";